module.exports = __webpack_public_path__ + "img/view-live.8e488f0e.svg";